// extracted by mini-css-extract-plugin
export var actionButton = "_lh-t";
export var buttonContainer = "_lh-0";
export var buttonContainer2 = "_lh-1";
export var buttonSection = "_lh-2";
export var details = "_lh-3";
export var dropdownItem = "_lh-5";
export var dropdownItemsContainer = "_lh-4";
export var fileInput = "_lh-r";
export var headerButton = "_lh-6";
export var icon = "_lh-7";
export var input = "_lh-8";
export var macroListItem = "_lh-9";
export var mainContent = "_lh-a";
export var microText = "_lh-b";
export var modal = "_lh-w";
export var optionsButton = "_lh-c";
export var paperclip = "_lh-s";
export var pillContent = "_lh-d";
export var preview = "_lh-e";
export var preview2 = "_lh-f";
export var quillEditor = "_lh-q";
export var selectedMacro = "_lh-g";
export var sidebar = "_lh-h";
export var sidebarHeader = "_lh-j";
export var sidebarList = "_lh-i";
export var sidebarListItem = "_lh-k";
export var sidebarSearch = "_lh-l";
export var snoozeDurationWrapper = "_lh-v";
export var statusPillContainer = "_lh-m";
export var tagsContainer = "_lh-n";
export var unselectedMacro = "_lh-o";
export var variable = "_lh-u";
export var wrapper = "_lh-p";